<template>
    <slot></slot>
</template>

<script lang="ts" setup>
import { inject, type Ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useRedirect } from '@/ssr/plugins/redirect.ts'

import { getRoutingRegion, noPrefixRegion } from '@/plugins/region'

const props = defineProps<{
    region: string
}>()

const router = useRouter()
const redirect = useRedirect()

const isInitialized = inject('isInitialized') as Ref<boolean>

function onRegionChange(region: string): void {
    if (noPrefixRegion !== region.toUpperCase()) {
        return
    }

    // @ts-expect-error alabala
    const resolved = router.resolve({
        ...router.currentRoute.value,
        params: {
            ...router.currentRoute.value.params,
            region: getRoutingRegion(noPrefixRegion),
        },
    })

    redirect(resolved.href, 301)
}

if (import.meta.env.SSR) {
    onRegionChange(props.region)
} else {
    let isWatching = false

    watch(
        isInitialized,
        (n) => {
            if (isWatching) {
                return
            }

            if (!n) {
                return
            }

            isWatching = true

            // Redirect from noPrefixRegion (for example /uk) to /
            watch(
                () => props.region,
                (n) => {
                    // If props.region is the noPrefixRegion, we must redirect to a location where
                    // The region prop is an empty string
                    onRegionChange(n)
                },
                { immediate: true }
            )
        },
        {
            immediate: true,
        }
    )
}
</script>
